import Vue from 'vue'
import Mapa from './Mapa'

import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

Vue.filter("truncate", (texto, limite) => {
  if (texto.length > limite) {
    texto = texto.substring(0, limite - 3) + "...";
  }
  return texto;
});

Vue.filter("humanTime", (tiempo) => {
  let [horas, minutos] = [parseInt(tiempo/60), tiempo % 60];
  if (minutos < 10) minutos = '0'+minutos.toString();
  return `${horas}:${minutos}`;
});

Vue.filter("humanDistance", (distancia) => {

  const [kilometros, metros] = [distancia/1000, distancia % 1000];
  if(kilometros>1)
    return `${kilometros.toFixed(1)} Km`;
  else
    return `${metros} m`;

});

new Vue({
  el:"visorPrames",
  components: {
    visor: Mapa
  },
  data: {
    idoma:'es',
    refugios: [],
    rutas: []
  },
  beforeMount() {
    if(this.$el.attributes["idioma"]) {
      //this.idioma = this.$el.attributes["idioma"].value;
      this.idioma = (['es','fr','en','cat'].includes(this.$el.attributes["idioma"].value) ? this.$el.attributes["idioma"].value : 'es');
    } else this.idioma = 'es'

    if(this.$el.attributes['refugios'])
      this.refugios = this.$el.attributes['refugios'].value.split(',')
    if(this.$el.attributes['rutas'])
      this.rutas = this.$el.attributes['rutas'].value.split(',')
  },
  render(h) {
    return h(Mapa, { props: { idioma: this.idioma, refugios: this.refugios, rutas: this.rutas } })
  }
});
